export default "__VITE_ASSET__acb951d1__"